<div class="WhoseCovered">
  <label [innerHTML]="individualsCoveredConfig?.label"></label>
  <section class="WhoseCovered__coverageSection">
    @for (
      whoseCoveredOption of whoseCoveredOptions | keyvalue: keepOrder;
      track whoseCoveredOption;
      let i = $index
    ) {
      <div
        class="WhoseCovered__coverageOption"
        [attr.aria-label]="whoseCoveredOptions[whoseCoveredOption.key].label"
        [ngClass]="{
          'is-active':
            whoseCoveredOptions[whoseCoveredOption.key]?.value ===
            whoseCoveredSelectedValue,
        }"
        (click)="
          buildMemberForm(whoseCoveredOptions[whoseCoveredOption.key].value)
        "
      >
        <div class="WhoseCovered__coverageOptionAvatar">
          <!-- <i *ngIf="whoseCoveredOptions[whoseCoveredOption.key].icon.indexOf(':') == -1" class="icon icon--medium">
          {{ whoseCoveredOptions[whoseCoveredOption.key]?.icon }}
        </i> -->
          @if (
            whoseCoveredOptions[whoseCoveredOption.key].icon.indexOf(':') == -1
          ) {
            <icon
              [config]="{ size: 'large' }"
              [name]="whoseCoveredOptions[whoseCoveredOption.key].icon"
              class="icon"
              data-test-id="'whoseCoverageOptionIcon-' + i"
            ></icon>
          }
        </div>
        <p
          class="t-data t-bold t-alt"
          [innerHTML]="whoseCoveredOptions[whoseCoveredOption.key].label"
          data-test-id="'whoseCoverageOptionLabel-' + i"
        ></p>
      </div>
    }
  </section>
</div>

@if (showSubscriber) {
  <whose-covered-form
    [whoseCoveredGroup]="whoseCoveredGroup"
    [config]="config"
    [subSpouseConfig]="subscriberConfig"
    [isOverSixtyFive]="isSubscriberOverSixtyFive"
    [isSubscriberOnly]="isSubscriberOnly"
    [maxAgeLimit]="maxAgeForSubscriber"
    [showSubscriber]="showSubscriber"
    [whoseCoveredValue]="whoseCoveredValue"
    [hasParentDependents]="hasParentDependents"
    (addDependent)="addDependent($event)"
    data-test-id="whoseCoveredSubscriberForm"
  >
  </whose-covered-form>
}
@if (showSpouse) {
  <whose-covered-form
    [whoseCoveredGroup]="whoseCoveredGroup"
    [config]="config"
    [subSpouseConfig]="spouseConfig"
    [isOverSixtyFive]="isSpouseOverSixtyFive"
    [maxAgeLimit]="maxAgeForSpouse"
    [showSpouse]="showSpouse"
    (removeDependent)="removeDependent($event)"
    data-test-id="whoseCoveredSpouseForm"
  >
  </whose-covered-form>
}
@if (showChild || showChildOnly) {
  <whose-covered-form
    [whoseCoveredGroup]="whoseCoveredGroup"
    [config]="config"
    [childOnlyConfig]="childOnlyConfig"
    [dependentVal]="dependentVal"
    (removeDependent)="removeDependent($event)"
    [dependentConfig]="dependentConfig"
    [depLimit]="childLimit"
    [dependentButtonConfig]="dependentButtonConfig"
    [showChildOnly]="showChildOnly"
    [showChild]="showChild"
    [whoseCoveredValue]="whoseCoveredValue"
    (addDependent)="addDependent($event)"
    data-test-id="whoseCoveredChildForm"
  >
  </whose-covered-form>
}
@if (showParent) {
  <whose-covered-form
    [whoseCoveredGroup]="whoseCoveredGroup"
    [config]="config"
    [showChildOnly]="showChildOnly"
    [dependentVal]="parentDependentVal"
    (removeDependent)="removeDependent($event)"
    [dependentConfig]="parentDependentConfig"
    [depLimit]="config?.parentLimit"
    [dependentButtonConfig]="parentButtonConfig"
    [showParent]="showParent"
    [whoseCoveredValue]="whoseCoveredValue"
    (addDependent)="addDependent($event)"
    data-test-id="whoseCoveredParentForm"
  >
  </whose-covered-form>
}
